// extracted by mini-css-extract-plugin
module.exports = {"title":"Unlock_title__Ba2U9","text":"Unlock_text__bF9lY","info":"Unlock_info__3iyGa","input":"Unlock_input__cfdW7","btns":"Unlock_btns__TYeuV","button":"Unlock_button__2pdFd"};